import { NavigationGuardNext, Route, RawLocation } from 'vue-router';
import getLoginStatus from '@pro/common/utils/getLoginStatus';
import storage from '@pro/common/dao/storage';
import clearLocalLoginState from '@pro/common/utils/clearLocalLoginState';
import { PagePermissions } from '@pro/common/declarations/page-permission';
import minimatch from 'minimatch';
import logoutOnehikid from '@pro/common/utils/logoutOnehikid';
import isSupport from '@pro/common/utils/isSupport';
import Cookie from 'js-cookie';

export const DEPRECATED_PAGE: Record<string, RawLocation> = {
  '/EPartner': {
    name: 'login'
  },
  '/MyAccount/employeeData': {
    path: '/installer/basic/employees'
  },
  '/MyAccount/companyData': {
    path: '/installer/basic/company'
  }
};

/**
 * 登录中页面
 */
export const IN_LOGIN_PATH: PagePermissions = [
  { path: '/authorizationCode' },
  { path: '/check' },
  { path: '/invitedRegisterAfter' },
  { path: '/thirdJump/*' },
  { path: '/ticketJump/*' }
];

/**
 * 重定向页面，这种页面不会进入权限鉴定流程
 */
export const REDIRECT_PATH: PagePermissions = [
  { path: '/login' },
  { path: '/invitedRegister' },
  { path: '/Register' },
  { path: '/Product/screenshot' }, // ep要求添加，73期敏捷
  ...IN_LOGIN_PATH
];

/**
 * 取出search和hash中的参数，以字符串的方式重新组装成hash
 */
function getURLQuery() {
  let flag = false;
  let tempSearch = '';
  let tempHash = '';
  if (window.location.search) {
    flag = true;
    tempSearch = window.location.search.substring(1);
  }
  if (window.location.hash.indexOf('?') >= 0) {
    flag = true;
    tempHash = window.location.hash.substring(window.location.hash.indexOf('?') + 1);
  }
  if (flag) {
    return `#?${ tempSearch }${tempSearch ? '&' : '' }${tempHash}`;
  }
  return '';
}

export default function globalGuard(to: Route, from: Route, next: NavigationGuardNext) {
  // 兼容旧路由链接，转为installer
  if (to.path.includes('hik-proconnect')) {
    next({
      path: to.path.replace('hik-proconnect', 'installer'),
      query: to.query,
      params: to.params
    });
    return;
  }
  if (to.name === 'login' || to.path === '/login') {
    clearLocalLoginState();
    logoutOnehikid();
    return;
  }
  if (to.fullPath === '/?act=login' || to.fullPath === '/?act=register') {
    window.location.href
      = `/lp/index.html${ window.indexHash }${to.fullPath === '/?act=login' ? '&act=login' : '&act=register'}`;
    return;
  }

  // 如果链接是邀请员工链接，不管已登录还是未登录都跳到落地页
  if (to.path === '/invitedRegister') {
    clearLocalLoginState();
    logoutOnehikid(`${window.location.origin }/lp/index.html${ window.indexHash }${getURLQuery()}`);
    return;
  }

  // 如果是工单域名，不让打开非工单路由页面
  if (isSupport() && !to.path.startsWith('/support/')) {
    next(false);
    return;
  }

  if (IN_LOGIN_PATH.some((item) => minimatch(to.path, item.path as string))) {
    to.query.fromOldApps = to.path;
    next({
      path: '/',
      query: to.query,
      params: to.params
    });
    return;
  }

  if (DEPRECATED_PAGE[to.path]) {
    next(DEPRECATED_PAGE[to.path]);
    return;
  }

  const havenLogin = getLoginStatus();
  const isB2B = (storage.get(storage.NAME.USER) as any).epSapId;
  // 如果是B2B用户，避免让他们进入另外两个首页,B2B 的时候使用JSESSIONID辅助判断登录状态
  if (havenLogin && isB2B && to.path === '/' && Cookie.get('JSESSIONID')) {
    window.location.href = '#/Order';
    return;
  }
  if (to.path === '/' && havenLogin && !isB2B && !to.fullPath.includes('fromOldApps')) {
    next({ path: '/installer/basic/home' });
    return;
  }
  next();
}
